module.exports = __webpack_public_path__ + "static/img/title5.8397a673.png";